import React, { useMemo } from 'react';
import { isMobile, useTranslation } from '@pascal/pascal-core';
import { MainBetsInfo } from './mainBetsInfo';

function MainBets({
  viewType,
  children,
  name,
  handleDoChip,
  betType,
  chipByTypes,
  quickBets,
  isBetsClosed,
  activeFreeBet,
}) {
  const t = useTranslation();

  const chip = useMemo(() => {
    if (!chipByTypes?.[betType]) {
      return null;
    }

    if (chipByTypes?.[betType].hasOwnProperty('winAmount')) {
      if (chipByTypes?.[betType].winAmount) {
        return chipByTypes?.[betType];
      }
      return 0;
    }
    return chipByTypes?.[betType];
    // eslint-disable-next-line
  }, [chipByTypes]);

  return (
    <div
      className={`${isMobile() ? 'mob' : 'bottom'}-center-column-inner-items ${
        isBetsClosed ? 'inactive' : ''
      } type-${viewType} 
      ${chip && chip.winAmount ? 'win' : ''}
      ${chip && chip.amount && !chip.winAmount ? 'active chips-done' : ''}`}
      onClick={() => {
        handleDoChip(betType);
      }}
    >
      <MainBetsInfo
        betType={betType}
        chip={chip ? chip.winAmount || chip.amount : 0}
        t={t}
        activeFreeBet={activeFreeBet}
        name={name}
        quickBets={quickBets}
      >
        {children}
      </MainBetsInfo>
    </div>
  );
}

export default MainBets;
